module.exports = __webpack_public_path__ + "img/ma-back.ddc75308.png";